import request from '@/utils/request.js';
import { tg_sort_ASCII } from '@/utils';

// - 获取活动全局配置信息
export const actInfoApi = (overall_id) =>
  request({
    url: `/v1/permanent_sign_in/act_info/${overall_id}`,
    method: 'get',
  });

// - 获取当前用户状态
export const userInfoApi = (overall_id) =>
  request({
    url: `/v1/permanent_sign_in/user_info/${overall_id}`,
    method: 'get',
  });

// - 签到
export const signApi = (overall_id) =>
  request({
    url: `/v1/permanent_sign_in/user_sign_in/${overall_id}`,
    method: 'post',
  });

//- 获取活动全局配置下的游戏会场配置 - 首页最多展示5个
export const firstPageApi = (overall_id) =>
  request({
    url: `/v1/permanent_sign_in/game_list_first_page/${overall_id}`,
    method: 'get',
  });

// - 获取活动全局配置下的游戏会场配置 - 更多游戏
export const moreGameApi = (overall_id) =>
  request({
    url: `/v1/permanent_sign_in/game_list_more/${overall_id}`,
    method: 'get',
  });

// - 获取游戏会场配置下的福利配置
export const welfareApi = (overall_id, params) =>
  request({
    url: `/v1/permanent_sign_in/game_welfare_list/${overall_id}`,
    method: 'get',
    params
  });

// - - 领取福利
export const getWelfareApi = (overall_id, data) =>
  request({
    url: `/v1/permanent_sign_in/get_welfare/${overall_id}`,
    method: 'post',
    data
  });

// - 礼包领取记录
export const receiveApi = (overall_id, params) =>
  request({
    url: `/v1/permanent_sign_in/welfare_user_receive/${overall_id}`,
    method: 'get',
    params
  });

// - 埋点上报
export const burnReport = (data) =>
  request({
    url: `/v1/report_data/async`,
    method: 'post',
    data
  });

// - 礼包领取记录
export const disperseApi = (overall_id, params) =>
  request({
    url: `/v1/permanent_sign_in/disperse/${overall_id}`,
    method: 'get',
    params
  });

// 游戏排行榜数据
export const rankGameListApi = (params) =>
  request({
    url: `/v1/game/sign_in_act_list`,
    method: 'get',
    params
  });
